import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-deliveryterms',
  templateUrl: './deliveryterms.component.html',
  styleUrls: ['./deliveryterms.component.scss']
})
export class DeliverytermsComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
